import { Component, ViewChild, ElementRef, AfterViewInit, AfterViewChecked, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Chart } from 'src/app/utils/chart-config';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { HttpService } from 'src/app/services/http.service';
import { ConfigurationSaisieDonneesAnalyse } from '../../bo/configurationSaisieDonneesAnalyse';
import { Graphique } from '../../bo/graphique';
import { Probleme } from '../../bo/probleme';
import { Projet } from '../../bo/projet';
import { ReferentielDonneeAnalyse } from '../../bo/referentielDonneeAnalyse';
import { TypeTir } from '../../bo/TypeTir';
import { Zone } from '../../bo/zone';
import { DateInterval, FonctionsService } from '../../services/fonctions-partagees.service';
import { TraductionService } from '../../services/traduction.service';
import { UtilisateurService } from '../../services/utilisateur.service';
import { NgForm } from '@angular/forms';
import { KeycloakUtilisateurService } from 'src/app/services/keycloak/keycloak-utilisateur.service';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-plot-kpis',
  templateUrl: './plot-kpis.component.html',
  styleUrls: ['./plot-kpis.component.scss'],
  standalone: false
})
export class PlotKpisComponent implements AfterViewInit, AfterViewChecked {
  @ViewChild('modalNomGraph') modalNomGraph: ModalDirective;
  @ViewChild('modalDejaAjoute') modalDejaAjoute: ModalDirective;
  @ViewChild('lineChart') lineChartRef: ElementRef<HTMLCanvasElement>;
  @ViewChild('boxPlotChart') boxPlotChartRef: ElementRef<HTMLCanvasElement>;
  chartParametre = "";
  traductions: string[] = [];
  sauvChartParametre = "";
  dataLoading = false;
  loading = false;
  tabProjets: Projet[] = [];
  tabProblemes: Probleme[] = [];
  tabZones: Zone[] = [];
  tabTypesTir: TypeTir[] = [];
  typeTirSelectionnees: TypeTir[] = [];
  tabEchelle: string[] = [];
  refEchelles: any[] = [];
  nominal = [];
  min = [];
  max = [];
  echelleX = "Tir";
  problemeSelectionne: Probleme[] = [];
  tabRefDonneeAnalyse: ConfigurationSaisieDonneesAnalyse[];
  dataSelectionnee: ConfigurationSaisieDonneesAnalyse[];
  zoneSelectionnee: Zone;
  selections: any[] = [];
  langueCourante: string;
  minDate: string;
  maxDate: string;
  tabPeriodes: any[] = [];
  periodeSelectionnee: string;
  chartType = "";
  tabDates: Date[] = [];
  rangeStart: Date | null = null;
  rangeEnd: Date | null = null;
  combinedChartData: any = null;
  showIcon = true;
  showError = false;
  saveActive = false;


  ///** LINE CHART **//
  lineChartData: any;
  lineChartOptions: any = {
    maintainAspectRatio: false,
    responsive: true,
    legend: {
      position: 'bottom',
      labels: { usePointStyle: true }
    },
    elements: {
      point: {
        radius: 0
      }
    },
    scales: {
      y: {
        position: "left",
        ticks: {
          beginAtZero: true,
          color: '#7E003F'
        }
      }
    }
  };

  //**BOX PLOT**//
  boxPlotData: any;
  boxPlotOptions: any = {
    maintainAspectRatio: false,
    tooltipDecimals: 2,
    legend: {
      position: 'bottom',
      labels: { usePointStyle: true }
    },
    elements: {
      point: {
        radius: 0
      }
    }
  };
  chartLabels: any[];
  tabTypeGraph: { nom: any; valeur: string; }[];

  
  private lineChart: any = null;
  private boxPlotChart: any = null;
  private chartNeedsUpdate = false;

  constructor(
    private readonly tradService: TraductionService,
    private readonly http: HttpService,
    private readonly utilService: UtilisateurService,
    private readonly route: ActivatedRoute,
    private readonly fonctionsService: FonctionsService,
    private readonly keycloakUtilisateurService: KeycloakUtilisateurService,
    private readonly cdr: ChangeDetectorRef
    ) {
    this.langueCourante = tradService.translate.currentLang;
    this.tradService.langueCourante$.subscribe(resultat => {
      this.langueCourante = resultat;
    });
    this.tradService.translate.get(['GLOBAL.TIR', 'GLOBAL.JOURS', 'GLOBAL.SEMAINE', 'GLOBAL.MOIS', 'GLOBAL.30JOURS', 'GLOBAL.7JOURS', 'GLOBAL.DERNIER_MOIS', 'GLOBAL.ANNEE_COURANTE', 'GLOBAL.12DERNIERS_MOIS',
      'GLOBAL.LIGNE', 'GLOBAL.BOX_PLOT', 'GLOBAL.NOMBRE_TIR', 'GLOBAL.GRAPH_COMBINE', 'GLOBAL.MOYENNE']).subscribe(traduction => {
        this.traductions = traduction;
        this.refEchelles = [
          { nom: traduction['GLOBAL.TIR'], valeur: 'Tir' },
          { nom: traduction['GLOBAL.JOURS'], valeur: 'Jours' },
          { nom: traduction['GLOBAL.SEMAINE'], valeur: 'Semaine' },
          { nom: traduction['GLOBAL.MOIS'], valeur: 'Mois' }
        ];
        this.tabEchelle = this.refEchelles;
        this.tabPeriodes = [{ nom: traduction["GLOBAL.30JOURS"], valeur: "30jours" }, { nom: traduction["GLOBAL.7JOURS"], valeur: "7jours" }, { nom: traduction["GLOBAL.DERNIER_MOIS"], valeur: "dernierMois" },
        { nom: traduction["GLOBAL.ANNEE_COURANTE"], valeur: "anneeCourante" }, { nom: traduction["GLOBAL.12DERNIERS_MOIS"], valeur: "12Mois" }];
        // this.tabTypeGraph = [{ nom: traduction["GLOBAL.LIGNE"], valeur: "Ligne" }, { nom: traduction["GLOBAL.BOX_PLOT"], valeur: "Box plot" }, { nom: traduction["GLOBAL.GRAPH_COMBINE"], valeur: "combine" }]
        this.tabTypeGraph = [{ nom: traduction["GLOBAL.LIGNE"], valeur: "Ligne" }, { nom: traduction["GLOBAL.BOX_PLOT"], valeur: "Box plot" }]
      });
  }

  ngOnInit() {
  //  this.saveActive =  (!this.boxPlotData && !this.lineChartData && !this.combinedChartData);
    var saveSiteId = this.utilService.currentSite().siteId;
    this.route.params.subscribe((params) => {

      if (params.id == undefined) {
          params.id = this.utilService.currentSite().siteId;
      }

      this.dataSelectionnee = [];
      this.problemeSelectionne = [];
      if (this.utilService.currentSite().siteId != saveSiteId) {
        saveSiteId = this.utilService.currentSite().siteId;
        this.clearAll();
      }
      this.http.get("Sites/" + params.id + "/BlastTypes").subscribe((res: TypeTir[]) => {
        setTimeout(() => { this.tabTypesTir = res; });
      })
      this.http.get('Sites/' + params.id + '/AvailableAnalysisData').subscribe((res: ConfigurationSaisieDonneesAnalyse[]) => {
        setTimeout(() => {
          this.tabRefDonneeAnalyse = res;
          this.tabRefDonneeAnalyse.forEach((conf: ConfigurationSaisieDonneesAnalyse) => {
            this.tradService.translate.get(conf.referentielDonneeAnalyse.nom).subscribe(translation => conf.referentielDonneeAnalyse.nom = translation);
          });
        });
      }, (error:HttpErrorResponse) => {
        if(error.status === 401 || error.status === 403){
           console.log(error.error);
          }
        });
        
      this.http.get('Sites/' + params.id + '/AvailableOpData').subscribe((res: Probleme[]) => {
        setTimeout(() => { this.tabProblemes = res; });
      });
      this.http.get<Projet[]>('Sites/' + params.id + '/Projects').subscribe(resultat => {
        setTimeout(() => { this.tabProjets = resultat; });
      }, () => {
        this.fonctionsService.launch_toast(false);
      });
      this.http.get('Sites/' + params.id + '/Zones').subscribe((resultat: Zone[]) => {
        setTimeout(() => { this.tabZones = resultat; });
      }, () => {
        this.fonctionsService.launch_toast(false);
      });
    });
  }

  // (error:HttpErrorResponse) => {
  //   if(error.status === 401 || error.status === 403){
  //      window.location.href='/';
  //   }

  protected onSubmit(form: NgForm) {
    if(!form.valid){
      this.showError = true;
      setTimeout(() => {
        this.showError = false;
      }, 1500);
      return;
    }
    this.showIcon = false;

    this.refreshData();
  }

  onChangePeriode() {
    let dates: DateInterval = this.fonctionsService.getDateFromPeriode(this.periodeSelectionnee);
    this.rangeStart = new Date(dates.dMin);
    this.rangeEnd = new Date(dates.dMax);
    this.dateChange([this.rangeStart, this.rangeEnd]);
  }

  onDateRangeChanged() {
    if (this.rangeStart && this.rangeEnd) {
      this.dateChange([this.rangeStart, this.rangeEnd]);
      return;
    }
    this.dateChange(null);
  }

  dateChange(e: any) {
    if (e) {
      this.minDate = new Date(e[0]).toISOString().split('T')[0];
      this.maxDate = new Date(e[1]).toISOString().split('T')[0];
    } else {
      this.minDate = null;
      this.maxDate = null;
    }
    this.tabRefDonneeAnalyse = [];
    this.dataSelectionnee = [];
    this.problemeSelectionne = [];
    if (this.minDate && this.maxDate) {
      this.lineChartData = null;
      this.boxPlotData = null;
      this.updateAvailableData();
    }
  }

  updateAvailableData() {
    let rqTypeTirIds = "";
    this.loading = true;
    this.dataSelectionnee = [];
    this.problemeSelectionne = [];
    this.selections = [];
    this.tabRefDonneeAnalyse = [];
    this.typeTirSelectionnees.forEach(p => rqTypeTirIds += "&typeTirId=" + p.typeTirId);
    this.http.get('Sites/' + this.utilService.currentSite().siteId + '/AvailableAnalysisData?dMin=' + this.minDate + '&dMax=' + this.maxDate + '&periode=' + this.periodeSelectionnee + rqTypeTirIds).subscribe((res: ConfigurationSaisieDonneesAnalyse[]) => {
      this.tabRefDonneeAnalyse = res;
      this.tabRefDonneeAnalyse.forEach((conf: ConfigurationSaisieDonneesAnalyse) => {
        this.tradService.translate.get(conf.referentielDonneeAnalyse.nom).subscribe(translation => conf.referentielDonneeAnalyse.nom = translation);
      });
      if (this.chartType == "Ligne") {
        let fakeNbLigne = new ConfigurationSaisieDonneesAnalyse();
        fakeNbLigne.referentielDonneeAnalyse = new ReferentielDonneeAnalyse();
        fakeNbLigne.referentielDonneeAnalyse.nom = this.traductions["GLOBAL.NOMBRE_TIR"];
        fakeNbLigne.referentielDonneeAnalyseId = -1;
        this.tabRefDonneeAnalyse.push(fakeNbLigne);
      }
      this.loading = false;
    });
  }

  nettoyerDates() {
    this.rangeStart = null;
    this.rangeEnd = null;
    this.dateChange(null);
  }

  clearAll() {
    this.rangeStart = null;
    this.rangeEnd = null;
    this.minDate = null;
    this.maxDate = null;
    this.periodeSelectionnee = undefined;
    this.tabRefDonneeAnalyse = [];
    this.dataSelectionnee = [];
    this.problemeSelectionne = [];
    this.zoneSelectionnee = null;
    this.selections = [];
    this.typeTirSelectionnees = [];
    this.boxPlotData = null;
    this.lineChartData = null;
    this.combinedChartData = null;
    this.saveActive = false;
    this.echelleX = 'Tir';

  }

  onChangetypeTir() {
    if (this.minDate && this.maxDate && (this.dataSelectionnee.length > 0 || this.problemeSelectionne.length > 0)) {
      this.refreshData();
    }
  }
  
  protected onRemoveDonneeAnalyse(event:any){
  }

  onChangeTypeChart() {
    if (this.chartType == "Box plot") {
      this.tabEchelle = this.refEchelles.filter(p => p.valeur != "Tir");
      this.echelleX = 'Jours';
    } else {
      this.tabEchelle = this.refEchelles;
    }
    this.clearAll();
  }

  onchangeEchelleX() {
    if (this.minDate && this.maxDate && (this.dataSelectionnee.length > 0 || this.problemeSelectionne.length > 0)) {
      this.refreshData();
    }
  }

  onChangeZone() {
    this.refreshData();
  }

  save(e: any) {
    if (!this.boxPlotData && !this.lineChartData && !this.combinedChartData) return;
    if (this.chartParametre == this.sauvChartParametre) {
      this.modalNomGraph.hide();
      this.modalDejaAjoute.show();
      return;
    }
    let graph = new Graphique();
    if (this.chartParametre.includes("BoxPlotChart")) {
      graph.type = "BoxPlotChart";
    } else if (this.chartParametre.includes("CombinedChart")) {
      graph.type = "CombinedChart";
    } else {
      graph.type = "LineChart";
    }

    graph.nom = e.target[0].value;
    e.target[0].value = "";
    graph.siteId = this.utilService.currentSite().siteId;
    graph.parametre = this.chartParametre;
    graph.utilisateurId = this.keycloakUtilisateurService.userProfile.id;

    graph.labels = JSON.stringify(this.chartLabels);

    this.http.post("Chart", graph).subscribe(res => {
      this.sauvChartParametre = this.chartParametre;
      this.modalNomGraph.hide();
      this.fonctionsService.launch_toast(true);
    }, error => {
      this.fonctionsService.loading_screen(false);
    })

    this.saveActive = false;
  }

  openModalNomGraph() {
    if (this.boxPlotData || this.lineChartData || this.combinedChartData)
      this.modalNomGraph.show();
  }

  //Reinitialisation du graphique
  refreshData() {
    if (!this.minDate || !this.maxDate || (this.dataSelectionnee.length == 0 && this.problemeSelectionne.length == 0)) {
      this.boxPlotData = null;
      this.lineChartData = null;
      this.combinedChartData = null;
      return;
    }

    if (this.chartType == "Box plot") {
      if (!this.dataSelectionnee[0]) return;
      this.dataLoading = true;
      this.cdr.markForCheck();
      this.problemeSelectionne = [];
      this.selections = [];
      this.chartLabels = [];
      this.boxPlotData = null;

      let rqTypeTirIds = "";
      this.typeTirSelectionnees.forEach((type) => {
      rqTypeTirIds += "&typeTirId=" + type.typeTirId.toString() 
      })

      let zone = "";
      zone = this.zoneSelectionnee === null ? " " : this.zoneSelectionnee.zoneId.toString(); 

      this.chartParametre = "BoxPlotChart?siteId=" + this.utilService.currentSite().siteId
        + "&periode=" + this.periodeSelectionnee
        + "&dMin=" + this.minDate
        + "&dMax=" + this.maxDate
        + rqTypeTirIds
        + "&echelleX=" + this.echelleX
        + "&refDonneeId=" + this.dataSelectionnee[0].referentielDonneeAnalyse.referentielDonneeAnalyseId.toString()
        + "&zone=" + zone


      //this.http.get("Chart/BoxPlotChart", {
      //  siteId: this.utilService.currentSite().siteId.toString(),
      //  periode: this.periodeSelectionnee,
      //  dMin: this.minDate,
      //  dMax: this.maxDate,
      //  zone: this.zoneSelectionnee != null ? this.zoneSelectionnee.zoneId.toString() : "",
      //  typeTirId: rqTypeTirIds,
      //  echelleX: this.echelleX,
      //  refDonneeId: this.dataSelectionnee[0].referentielDonneeAnalyse.referentielDonneeAnalyseId.toString()
      //})

      this.http.get("Chart/" + this.chartParametre)
        .subscribe((res: any) => {
          this.dataLoading = false;
          if (!res || !res.y || res.y.length === 0) {
            this.cdr.markForCheck();
            this.showIcon = true;
            return;
          }
          if (res) {
            var moys = [];
            const yData = res.y.map((v: any) => (v === '' || v === null) ? null : parseFloat(v));
            for (var i = 0; i < yData.length; i++) {
              const moyVal = res.moy !== null && res.moy !== undefined ? (typeof res.moy === 'string' ? parseFloat(res.moy) : res.moy) : null;
              if (moyVal !== null) moys.push(moyVal);
            }
            this.boxPlotData = {
              // define label tree
              labels: res.x,
              datasets: [
                {
                  label: this.dataSelectionnee[0] ? this.dataSelectionnee[0].referentielDonneeAnalyse.nom + " (" + this.dataSelectionnee[0].referentielDonneeAnalyse.nomUniteReferentiel + ")" : "",
                  backgroundColor: "rgba(106,0,63,0.3)",
                  borderColor: "#7E003F",
                  borderWidth: 2,
                  padding: 10,
                  itemRadius: 0,
                  data: yData
                },
                {
                  label: this.traductions['GLOBAL.MOYENNE'],
                  pointHitRadius: 2,
                  pointHitDetectionRadius: 0,
                  pointBackgroundColor: "#2B729B",
                  backgroundColor: "transparent",
                  borderColor: "#2B729B",
                  borderWidth: 2,
                  type: "line",
                  data: moys
                }
              ]
            };
            this.chartLabels = [this.dataSelectionnee[0] ? this.dataSelectionnee[0].referentielDonneeAnalyse.nom + " (" + this.dataSelectionnee[0].referentielDonneeAnalyse.nomUniteReferentiel + ")" : "", this.traductions['GLOBAL.MOYENNE']];
            this.saveActive = true;
            this.cdr.markForCheck();
            
            // Update the chart after boxplot data is loaded
            this.updateCharts();
            }
        }, () => { 
          this.dataLoading = false;
          this.cdr.markForCheck();
          this.fonctionsService.launch_toast(false);
         })
    } else if (this.chartType == "combine") {
      this.dataLoading = true;
      this.cdr.markForCheck();
      this.combinedChartData = null;
      this.chartParametre = "CombinedChart?siteId=" + this.utilService.currentSite().siteId + '&periode=' + this.periodeSelectionnee + "&dMin=" + this.minDate + "&dMax=" + this.maxDate + "&refDonneeId=" + this.dataSelectionnee[0].referentielDonneeAnalyse.referentielDonneeAnalyseId;
      this.http.get("Chart/" + this.chartParametre).subscribe((res: any) => {
        this.combinedChartData = res;
        this.dataLoading = false;
        this.cdr.markForCheck();
      }, () => { 
        this.dataLoading = false;
        this.cdr.markForCheck();
        this.fonctionsService.launch_toast(false);
      });
    } else {
      this.dataLoading = true;
      this.cdr.markForCheck();

      try {
        this.selections = (this.dataSelectionnee as Array<any>).concat(this.problemeSelectionne);  //Concatenation des deux selecteurs
      } catch (error) {
        
      }

      this.max = [];
      this.min = [];
      this.nominal = [];
      // Réinitialiser les échelles pour Chart.js v3+
      this.lineChartOptions.scales = { y: {} };
      this.lineChartData = null;
      let rqRefId = "";
      this.dataSelectionnee.forEach(p => { rqRefId += "&refDonneeId=" + p.referentielDonneeAnalyseId });
      this.problemeSelectionne.forEach(p => { rqRefId += "&pbId=" + p.problemeId });
      let rqTypeTirIds = "";
      this.typeTirSelectionnees.forEach(p => rqTypeTirIds += "&typeTirId=" + p.typeTirId);
      this.chartParametre = 'LineChart?siteId=' + this.utilService.currentSite().siteId + '&periode=' + this.periodeSelectionnee + "&dMin=" + this.minDate + "&dMax=" + this.maxDate + rqTypeTirIds + "&echelleX=" + this.echelleX + rqRefId;
      if (this.zoneSelectionnee !== null) {
        this.chartParametre += "&zone=" + this.zoneSelectionnee.zoneId;
      }
      this.chartLabels = [];
      this.http.get('Chart/' + this.chartParametre).subscribe((res: any) => {
        if (!res || res.length === 0) {
          this.dataLoading = false;
          this.showIcon = true;
          this.cdr.markForCheck();
          return;
        }
        //Gestion des axes Y, deux axes si deux courbes
        this.lineChartOptions.scales.y = { 
          position: "left", 
          beginAtZero: true,
          ticks: { 
            color: "#7E003F", 
            font: { weight: "bold" },
            callback: function (value: any) { 
              return value % 1 === 0 ? value : undefined;
            } 
          } 
        };
        if (res.length > 0) {
          if (this.dataSelectionnee[0]) {
            if (this.dataSelectionnee[0].referentielDonneeAnalyse.nomUniteReferentiel)
              var _label = this.dataSelectionnee[0].referentielDonneeAnalyse.nom + " (" + this.dataSelectionnee[0].referentielDonneeAnalyse.nomUniteReferentiel + ")";
            else
              var _label = this.dataSelectionnee[0].referentielDonneeAnalyse.nom;
          } else {
            var _label = this.problemeSelectionne[0].nom;
          }
          this.lineChartData = {
            // define label tree
            labels: res[0] ? res[0].x : [],
            datasets: [
              {
                lineTension: 0,
                pointHitRadius: 2,
                pointBackgroundColor: "#7E003F",
                label: _label,
                backgroundColor: "transparent",
                borderColor: "#7E003F",
                borderWidth: 2,
                yAxisID: "y",
                data: res[0] ? res[0].y.map((v: any) => (v === '' || v === null) ? null : parseFloat(v)) : [],
                type: 'line'
              }
            ]
          };
          this.chartLabels.push(_label);
        }
        if (res.length == 2) {
          if (this.selections[1].referentielDonneeAnalyse) {
            if (this.dataSelectionnee[1].referentielDonneeAnalyse.nomUniteReferentiel) {
              //this solves "Indicator - L'unité du 2eme KPI est fausse"
              var _label = this.dataSelectionnee[1].referentielDonneeAnalyse.nom + " (" + this.dataSelectionnee[1].referentielDonneeAnalyse.nomUniteReferentiel + ")";
            }
            else
              var _label = this.dataSelectionnee[1].referentielDonneeAnalyse.nom;
          } else {
            var _label = String(this.selections[1].nom);
          }
          this.lineChartOptions.scales.y1 = { 
            position: "right", 
            beginAtZero: true,
            ticks: { 
              color: "#2B729B", 
              font: { weight: "bold" },
              callback: function (value: any) { 
                if (value % 1 === 0) { return value; } 
              } 
            } 
          };
          this.lineChartData.datasets.push(
            {
              lineTension: 0,
              pointHitRadius: 2,
              pointBackgroundColor: "#2B729B",
              label: _label,
              backgroundColor: "transparent",
              borderColor: "#2B729B",
              borderWidth: 2,
              yAxisID: "y1",
              data: res[1] ? res[1].y.map((v: any) => (v === '' || v === null) ? null : parseFloat(v)) : [],
              type: 'line'
            }
          );
          this.chartLabels.push(_label);
        }

        //Ajout des courbes min, max, nominale si une seule data selectionnée
        if (res.length == 1) {
          for (let i = 0; i < res[0].x.length; i++) {
            if (this.selections[0].valeurMax) this.max.push(this.selections[0].valeurMax);
            if (this.selections[0].valeurMin) this.min.push(this.selections[0].valeurMin);
            if (this.selections[0].valeurNominal) this.nominal.push(this.selections[0].valeurNominal);
          };
          if (this.max.length) {
            this.lineChartData.datasets.push({ data: this.max, type: "line", borderColor: "#ccc", label: "max", steppedLine: true, backgroundColor: "transparent" });
            this.chartLabels.push("line");
          }
          if (this.min.length) {
            this.lineChartData.datasets.push({ data: this.min, type: "line", borderColor: "#ccc", label: "min", steppedLine: true, backgroundColor: "transparent" });
            this.chartLabels.push("min");
          }
          if (this.nominal.length) {
            this.lineChartData.datasets.push({ data: this.nominal, type: "line", borderColor: "#ccc", label: "nominale", borderDash: [10, 5], backgroundColor: "transparent" });
            this.chartLabels.push("nominale");
          }
        }

        this.saveActive = true;
        this.dataLoading = false;
        this.cdr.markForCheck();
        
        // Update the chart after data is loaded
        this.updateCharts();
      }, () => {
        this.dataLoading = false;
        this.cdr.markForCheck();
        this.fonctionsService.launch_toast(false);
      });
    }
  }

  ngAfterViewInit() {
    // Charts will be created when data is available
  }

  ngAfterViewChecked() {
    if (this.chartNeedsUpdate) {
      this.chartNeedsUpdate = false;
      if (this.chartType === 'Ligne' && this.lineChartData && this.lineChartRef) {
        this.createLineChart();
      } else if (this.chartType === 'Box plot' && this.boxPlotData && this.boxPlotChartRef) {
        this.createBoxPlotChart();
      }
    }
  }

  private createLineChart() {
    if (this.lineChartRef && this.lineChartData) {
      if (this.lineChart) {
        this.lineChart.destroy();
      }
      
      const ctx = this.lineChartRef.nativeElement.getContext('2d');
      this.lineChart = new Chart(ctx, {
        type: 'line',
        data: this.lineChartData,
        options: this.lineChartOptions
      });
    }
  }

  private createBoxPlotChart() {
    if (this.boxPlotChartRef && this.boxPlotData) {
      if (this.boxPlotChart) {
        this.boxPlotChart.destroy();
      }
      
      const ctx = this.boxPlotChartRef.nativeElement.getContext('2d');
      this.boxPlotChart = new Chart(ctx, {
        type: 'bar',
        data: this.boxPlotData,
        options: this.boxPlotOptions
      });
    }
  }

  private updateCharts() {
    this.chartNeedsUpdate = true;
  }
}
